module.exports = __webpack_public_path__ + "img/bell_fill.8d220ae8.svg";